import { render, staticRenderFns } from "./DetalhesVenda.vue?vue&type=template&id=3c79dd1c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./DetalhesVenda.vue?vue&type=script&lang=js&"
export * from "./DetalhesVenda.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesVenda.vue?vue&type=style&index=0&id=3c79dd1c&lang=scss&scoped=true&"
import style1 from "./DetalhesVenda.vue?vue&type=style&index=1&id=3c79dd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79dd1c",
  null
  
)

export default component.exports